/**
 * <TutorTrainingSkeleton> — la forme de « Ta formation » pendant son premier chargement : le titre
 * et la phrase de la vidéo, le cadre 16:9, puis l'encart du quiz.
 */
import React from "react"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"

export function TutorTrainingSkeleton() {
    return (
        <Stack gap="4">
            <Stack gap="2">
                <Skeleton textSize="text-xl" width={240} />
                <Skeleton textSize="text-lg" width="100%" />
                <Skeleton textSize="text-lg" width="70%" />
            </Stack>
            {/* Le cadre 16:9 de la vidéo, à sa hauteur de téléphone. */}
            <Skeleton shape="block" height={200} />
            <Card p="4" elevation="none" background="primary-soft">
                <Stack gap="1">
                    <Skeleton textSize="text-lg" width={180} />
                    <Skeleton textSize="text-lg" width="90%" />
                </Stack>
            </Card>
        </Stack>
    )
}
